import gql from 'graphql-tag';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';

export const supplyObjectFieldsFragment = gql`
  fragment AdminSupplyObjectFields on SupplyObject {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    name
  }

  ${sanityDocumentFieldsFragment}
`;